let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ipMfX")).then(() => parcelRequire('4Cs4A'));